const meta = {
  datasets: 'Datasets',
  budgeting: 'Budgets',
  'shape-logs': {
    display: 'hidden',
  },
};

export default meta;
